import { createContext } from 'react';

import type { SidebarToggleMeta } from './useSidebarState';

type SidebarContextType = {
  isVisible: boolean;
  toggle(meta?: SidebarToggleMeta): void;
};

export const SidebarContext = createContext<SidebarContextType | undefined>(undefined);
